/* tslint:disable */
import {
  Patient
} from '../index';

declare var Object: any;
export interface UserGoalEvaluationInterface {
  "userGoalId": string;
  "userGoalText": string;
  "date": Date;
  "categoryId": number;
  "rating": number;
  "id"?: any;
  "patientId"?: any;
  patient?: Patient;
}

export class UserGoalEvaluation implements UserGoalEvaluationInterface {
  "userGoalId": string;
  "userGoalText": string;
  "date": Date;
  "categoryId": number;
  "rating": number;
  "id": any;
  "patientId": any;
  patient: Patient;
  constructor(data?: UserGoalEvaluationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `UserGoalEvaluation`.
   */
  public static getModelName() {
    return "UserGoalEvaluation";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of UserGoalEvaluation for dynamic purposes.
  **/
  public static factory(data: UserGoalEvaluationInterface): UserGoalEvaluation{
    return new UserGoalEvaluation(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'UserGoalEvaluation',
      plural: 'UserGoalEvaluations',
      path: 'UserGoalEvaluations',
      idName: 'id',
      properties: {
        "userGoalId": {
          name: 'userGoalId',
          type: 'string'
        },
        "userGoalText": {
          name: 'userGoalText',
          type: 'string'
        },
        "date": {
          name: 'date',
          type: 'Date'
        },
        "categoryId": {
          name: 'categoryId',
          type: 'number'
        },
        "rating": {
          name: 'rating',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "patientId": {
          name: 'patientId',
          type: 'any'
        },
      },
      relations: {
        patient: {
          name: 'patient',
          type: 'Patient',
          model: 'Patient',
          relationType: 'belongsTo',
                  keyFrom: 'patientId',
          keyTo: 'id'
        },
      }
    }
  }
}
